export default function createSubscriptionStatus(element: HTMLElement) {
	Promise.all([
		import('react'),
		import('react-dom'),
		import('./subscription-status'),
	]).then(([React, ReactDOM, { default: SubscriptionStatus }]) => {
		const profilePage = element.hasAttribute('data-profile-page');
		ReactDOM.render(
			<SubscriptionStatus profilePage={!!profilePage} />,
			element,
		);
	});
}
